import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AngularFireDatabase } from 'angularfire2/database';
import { NetworkConnectionProvider } from './../../providers/network-connection/network-connection';
import 'rxjs/add/operator/map';
import * as firebaseApp from 'firebase/app';


/****************
 * Storage Persistente
 *****************/
import localforage from "localforage";
/*
  Generated class for the FirebaseServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/


@Injectable()
export class FirebaseServiceProvider {

    idToked;

    constructor(private adb: AngularFireDatabase, 
                public net: NetworkConnectionProvider) {

 }

}



// WEBPACK FOOTER //
// ./src/providers/firebase-service/firebase-service.ts